import React from "react";
import "./Scoreboard.css";

import PencilLogoGold from "../assets/Pencil_gold.svg";
import PencilLogoSilver from "../assets/Pencil_silver.svg";
import PencilLogoBronze from "../assets/Pencil_bronze.svg";

const Scoreboard = ({ activeCompetition, isLoading }) => {

    const renderUsers = () => {
        if (isLoading) {
            return (
                <div className="scoreboard-loading">
                    <div className="loading-spinner"></div>
                </div>
            );
        }

        if (!activeCompetition) {
            return (
                <div className="scoreboard-empty">
                    <h3>🏆 No Competition Selected</h3>
                    <p>Select a competition to view the leaderboard</p>
                </div>
            );
        }

        const topUsers = (activeCompetition.compInfo && activeCompetition.compInfo.results && activeCompetition.compInfo.results.topUsers) 
            ? activeCompetition.compInfo.results.topUsers 
            : activeCompetition.topUsers?.slice(0, 20) || [];

        if (topUsers.length === 0) {
            return (
                <div className="scoreboard-empty">
                    <h3>🎯 No Scores Yet</h3>
                    <p>Be the first to make a guess!</p>
                </div>
            );
        }

        return topUsers.map((user, index) => {
            const isCurrentUser = false; // You can add user comparison logic here
            const position = index + 1;
            
            return (
                <div 
                    key={`${user.username}_${index}`} 
                    className={`scoreboard-entry ${isCurrentUser ? 'current-user' : ''}`}
                >
                    <div className={`scoreboard-entry-position ${getPositionClass(position)}`}>
                        {position <= 3 ? (
                            <img 
                                alt={`${getPositionName(position)} place`} 
                                className="placement-logo" 
                                src={getPositionLogo(position)}
                            />
                        ) : (
                            <span>#{position}</span>
                        )}
                    </div>

                    <div className="scoreboard-entry-user">
                        <h4 className="user-name">{user.username}</h4>
                        <div className="user-stats">
                            <div className="stat-item">
                                <span className="stat-icon">🎯</span>
                                <span>Score: {user.score}</span>
                            </div>
                            {user.gamesPlayed && (
                                <div className="stat-item">
                                    <span className="stat-icon">🎮</span>
                                    <span>{user.gamesPlayed} games</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="score-display">
                        <p className="score-value">{user.score}</p>
                        <p className="score-label">Points</p>
                    </div>
                </div>
            );
        });
    }

    const getPositionClass = (position) => {
        switch (position) {
            case 1: return 'position-1';
            case 2: return 'position-2';
            case 3: return 'position-3';
            default: return 'position-other';
        }
    }

    const getPositionLogo = (position) => {
        switch (position) {
            case 1: return PencilLogoGold;
            case 2: return PencilLogoSilver;
            case 3: return PencilLogoBronze;
            default: return null;
        }
    }

    const getPositionName = (position) => {
        switch (position) {
            case 1: return 'Gold pencil for first';
            case 2: return 'Silver pencil for second';
            case 3: return 'Bronze pencil for third';
            default: return `${position}th`;
        }
    }

    return (
        <div className="scoreboard-container">
            <div className="scoreboard-entries-container">
                {renderUsers()}
            </div>
        </div>
    )
}

export default Scoreboard;